import {
    SET_UTILITY_ANNUAL_KWH,
    SET_UTILITY_ENERGY_VALUE,
    SET_UTILITY_PROVIDER,
    SET_UTILITY_ANNUAL_INFLATION,
    SET_UTILITY_ANNUAL_A_FIXED_CHARGE,
    SET_UTILITY_MONTHLY_KWH_INPUTS,
    SET_UTILITY_MONTHLY_FIXED_INPUTS,
    SET_UTILITY,
} from './constants';

import Months from '../../../utils/Months';

const monthkWHData = {};
for (let i = 0; i < Months.length; i += 1) {
    monthkWHData[Months[i]] = null;
}

const mFixedChargeData = {};
for (let i = 0; i < Months.length; i += 1) {
    mFixedChargeData[Months[i]] = null;
}


const defaultState = {
    annualInflation: 1.74,
    annualKWH: 0,
    energyValue: 0,
    provider: 'selectProvider',
    aFixedCharge: 0,
    monthlyKWh: monthkWHData,
    mFixedCharge: mFixedChargeData,
};

const utility = (state = defaultState, action) => {
    switch (action.type) {
        case SET_UTILITY:
            return {
                ...state,
                annualKWH: action.utility.annualConsumption,
                energyValue: action.utility.ratePerKwh,
                provider: action.utility.utilityType,
                annualInflation: action.utility.annualInflationPercentage,
                // aFixedCharge: action.utility.annualFixedCharge,
            };

        case SET_UTILITY_ANNUAL_KWH:
            return { ...state, annualKWH: action.annualKWH };

        case SET_UTILITY_ENERGY_VALUE:
            return { ...state, energyValue: action.energyValue };

        case SET_UTILITY_PROVIDER:
            return { ...state, provider: action.provider };

        case SET_UTILITY_ANNUAL_INFLATION:
            return { ...state, annualInflation: action.annualInflation };

        case SET_UTILITY_ANNUAL_A_FIXED_CHARGE:
            return { ...state, aFixedCharge: action.aFixedCharge };

        case SET_UTILITY_MONTHLY_KWH_INPUTS:
            return {
                ...state,
                monthlyKWh: {
                    ...state.monthlyKWh,
                    [action.month]: action.monthlyKWh,
                },
            };
        case SET_UTILITY_MONTHLY_FIXED_INPUTS:
            return {
                ...state,
                mFixedCharge: {
                    ...state.mFixedCharge,
                    [action.month]: action.mFixedCharge,
                },
            };
        default:
            return state;
    }
};

export default utility;



// WEBPACK FOOTER //
// ./src/containers/common/utility/reducer.js